module.exports = __webpack_public_path__ + "static/media/newspaper.7aec8849.svg";